import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["container", "backLink", "contentContainer", "heightSource"]

  connect() {
    // Upon connection, we make sure the contentContainer is always at least the height of the menu
    // We can't use the contentContainer itself for this, becuase it's absolutely positioned (and thereby
    // doesn't inherit it's height from it's children), so we need to have a heightSourceTarget defined

    // Only the settings page uses a contentContainerTarget & heightSourceTarget. Even though we check for it here, the version
    // of Stimulus that we use reports an error on the statistics page that it can't find this target. It doesn't affect
    // behaviour though.
    if (this.hasContentContainerTarget) {
      this.contentContainerTarget.style.minHeight = this.heightSourceTarget.getBoundingClientRect().height + 'px';
    }
    this.openOrCloseBasedOnUrlParam();
  }

  popState() { this.openOrCloseBasedOnUrlParam(); }

  openOrCloseBasedOnUrlParam() {
    // We have to unhide the contentContainer if it has been hidden by chooseItem
    // or else, we can end up with blank pages when using history navigation
    this.contentContainerTarget.classList.remove("hidden", "md:block")
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.has('open_menu') ? this.open() : this.close();
  }

  // This sets the content of the backLink to whatever has been clicked
  // However, this isn't much use if the page is reloaded. So we use this on the statistics page where the page is _not_ reloaded upon choosing an item.
  chooseAndShowItem(event) {
    // Get the first parent that is a link, because we might have clicked a span inside a link
    var link_element = event.target.closest("a")

  	this.backLinkTarget.innerHTML = link_element.innerHTML;
    this.toggle();
  }

  // We use this on the settings page where the whole page is reloaded.
  // We hide the contentContainerTarget while the page reloads because it simply looks better. 
  chooseItem() { 
    this.close(); 
    this.contentContainerTarget.classList.add("hidden", "md:block")
  }

  open() { 
    this.containerTarget.classList.add("active"); 
    const url = new URL(window.location);
    const searchParams = new URLSearchParams(window.location.search);
    if (!searchParams.has('open_menu')) { 
      url.searchParams.set("open_menu", "true");
      window.history.pushState({}, "", url);
    }
  }

  close()      { this.containerTarget.classList.remove("active"); }
  toggle()     { this.containerTarget.classList.toggle("active"); }
}